module.exports = __webpack_public_path__ + "media/svg-new/lockOff-abd20c50.svg";